function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/manager/rum-manager.ts
var PREFIX = "RUM_PROXY";
var isSSR = () => typeof window === "undefined";
var isRumMark = entry => entry.name.startsWith(PREFIX);
var isComponentEvent = event => event.componentId !== void 0;
var getComponentTimeline = (timeline, componentId) => timeline.filter(event => event.componentId === componentId);
var PerformanceRumManager = /*#__PURE__*/function () {
  function PerformanceRumManager(trackers) {
    _classCallCheck(this, PerformanceRumManager);
    this.trackers = trackers;
    this.handlePerformanceObserver = list => {
      const timeline = performance.getEntries().filter(isRumMark).map(({
        detail
      }) => detail);
      for (const entry of list.getEntries()) {
        if (entry.name.startsWith(PREFIX)) {
          const {
            detail: event
          } = entry;
          this.trackers.forEach(tracker => {
            tracker.trackEvent(event, isComponentEvent(event) ? getComponentTimeline(timeline, event.componentId) : timeline);
          });
        }
      }
    };
    if (isSSR()) {
      return;
    }
    this.performanceObserver = new PerformanceObserver(this.handlePerformanceObserver);
    this.performanceObserver.observe({
      type: "mark"
    });
  }
  return _createClass(PerformanceRumManager, [{
    key: "trackEvent",
    value: function trackEvent(event) {
      if (!this.performanceObserver) {
        return;
      }
      performance.mark(`${PREFIX}::${event.type}`, {
        detail: event,
        startTime: event.timestamp
      });
    }
    /**
     * Disconnects the performance observer
     * @remarks This should be called when the application is unmounted to avoid memory leaks
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/disconnect}
     * @internal
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _a;
      (_a = this.performanceObserver) == null ? void 0 : _a.disconnect();
      this.performanceObserver = void 0;
    }
  }]);
}();

// src/trackers/component-availability.ts
import { datadogRum } from "@datadog/browser-rum-slim";
var componentAvailabilityTracker = () => ({
  trackEvent: event => {
    const context = __spreadProps(__spreadValues({}, event.attributes), {
      componentName: event.componentName,
      componentId: event.componentId,
      startTime: event.timestamp
    });
    switch (event.type) {
      case "componentStart":
        datadogRum.addAction("COMPONENT_START", context);
        break;
      case "componentReadyForInteraction":
        datadogRum.addAction("COMPONENT_READY_FOR_INTERACTION", context);
        break;
      case "componentContentReady":
        datadogRum.addAction("COMPONENT_CONTENT_READY", context);
        break;
      case "componentFailed":
        datadogRum.addError(event.error.message, context);
        break;
      default:
        break;
    }
  }
});

// src/trackers/component-timing.ts
import { datadogRum as datadogRum2 } from "@datadog/browser-rum-slim";
var componentTimingTracker = () => {
  const activeSpans = /* @__PURE__ */new Map();
  return {
    trackEvent: event => {
      switch (event.type) {
        case "componentStart":
          {
            activeSpans.set(event.componentId, event);
            break;
          }
        case "componentFailed":
        case "componentReadyForInteraction":
          {
            const startEvent = activeSpans.get(event.componentId);
            if (startEvent) {
              datadogRum2.addDurationVital(event.componentName, {
                duration: event.timestamp - startEvent.timestamp,
                startTime: startEvent.timestamp + performance.timeOrigin
              });
              activeSpans.delete(event.componentId);
            }
            break;
          }
        default:
          break;
      }
    }
  };
};

// src/trackers/datadog.ts
import { datadogRum as datadogRum3 } from "@datadog/browser-rum-slim";
var datadogTracker = () => ({
  trackEvent: event => {
    switch (event.type) {
      case "action":
        datadogRum3.addAction(event.action, event.attributes);
        break;
      case "error":
        datadogRum3.addError(event.error, event.attributes);
        break;
      case "globalContextUpdate":
        datadogRum3.setGlobalContextProperty(event.key, event.value);
        break;
      default:
        break;
    }
  }
});
export { PerformanceRumManager, componentAvailabilityTracker, componentTimingTracker, datadogTracker };
//# sourceMappingURL=index.js.map